import { render, staticRenderFns } from "./MarketingAutomationFormStepsAddSend.vue?vue&type=template&id=9cb22d74&scoped=true"
import script from "./MarketingAutomationFormStepsAddSend.vue?vue&type=script&lang=js"
export * from "./MarketingAutomationFormStepsAddSend.vue?vue&type=script&lang=js"
import style0 from "./MarketingAutomationFormStepsAddSend.vue?vue&type=style&index=0&id=9cb22d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb22d74",
  null
  
)

export default component.exports